import { useTranslation } from '@providers/I18n';

type LocalizedValue = {
  arName: string;
  enName: string;
};

export const useLocalizedValue = (value: LocalizedValue | null | undefined) => {
  const { i18n } = useTranslation();

  if (!value) {
    return null;
  }

  if (i18n.language === 'ar') {
    return value.arName;
  }

  return value.enName;
};
